export default __webpack_public_path__ + "static/media/cover__image_kio.77bcc418.png";